import React from 'react';
import PropTypes from 'prop-types';
import SixAgeLimit from '../../assets/korhatar6.svg';
import TwelveAgeLimit from '../../assets/korhatar12.svg';
import SixteenAgeLimit from '../../assets/korhatar16.svg';
import EighteenAgeLimit from '../../assets/korhatar18.svg';
import NoAgeLimit from '../../assets/korhatar0.svg';
import SixAgeLimitE from '../../assets/korhatar6-e.svg';
import TwelveAgeLimitE from '../../assets/korhatar12-e.svg';
import SixteenAgeLimitE from '../../assets/korhatar16-e.svg';
import EighteenAgeLimitE from '../../assets/korhatar18-e.svg';
import NoAgeLimitE from '../../assets/korhatar0-e.svg';

const AgeLimit = ({ age }) => {
  switch (age) {
    case '6':
      return <SixAgeLimit key={age} />;
    case '12':
      return <TwelveAgeLimit key={age} />;
    case '16':
      return <SixteenAgeLimit key={age} />;
    case '18':
      return <EighteenAgeLimit key={age} />;
    case 'Korhatár nélkül':
      return <NoAgeLimit key={age} />;
    case '6 (E)':
      return <SixAgeLimitE key={age} />;
    case '12 (E)':
      return <TwelveAgeLimitE key={age} />;
    case '16 (E)':
      return <SixteenAgeLimitE key={age} />;
    case '18 (E)':
      return <EighteenAgeLimitE key={age} />;
    case 'Korhatár nélkül (E)':
      return <NoAgeLimitE key={age} />;
    case null:
      return null;
    default:
      return null;
  }
};

AgeLimit.propTypes = {
  age: PropTypes.string,
};

AgeLimit.defaultProps = {
  age: null,
};

export default AgeLimit;
